// automatically generated by the FlatBuffers compiler, do not modify
/**
 * @enum {number}
 */
export var Flatbuffers;
(function (Flatbuffers) {
    var Firmware;
    (function (Firmware) {
        let ThermostatAction;
        (function (ThermostatAction) {
            ThermostatAction[ThermostatAction["Heat"] = 1] = "Heat";
            ThermostatAction[ThermostatAction["Cool"] = 2] = "Cool";
            ThermostatAction[ThermostatAction["Circulate"] = 4] = "Circulate";
        })(ThermostatAction = Firmware.ThermostatAction || (Firmware.ThermostatAction = {}));
    })(Firmware = Flatbuffers.Firmware || (Flatbuffers.Firmware = {}));
})(Flatbuffers || (Flatbuffers = {}));
;
/**
 *
 * Temperatures are stored multiplied by 100, e.g. a temperature of 16.5 is stored as a 165.
 * Given that we're really just dealing with a range of 0-100, a multiplied-out range of 0-10000 fits just fine into a uint16.
 *
 *
 * @enum {number}
 */
(function (Flatbuffers) {
    var Firmware;
    (function (Firmware) {
        let ThermostatSettingType;
        (function (ThermostatSettingType) {
            ThermostatSettingType[ThermostatSettingType["Undefined"] = 0] = "Undefined";
            ThermostatSettingType[ThermostatSettingType["Hold"] = 1] = "Hold";
            ThermostatSettingType[ThermostatSettingType["Scheduled"] = 2] = "Scheduled";
        })(ThermostatSettingType = Firmware.ThermostatSettingType || (Firmware.ThermostatSettingType = {}));
    })(Firmware = Flatbuffers.Firmware || (Flatbuffers.Firmware = {}));
})(Flatbuffers || (Flatbuffers = {}));
;
/**
 * @enum {number}
 */
(function (Flatbuffers) {
    var Firmware;
    (function (Firmware) {
        let DaysOfWeek;
        (function (DaysOfWeek) {
            DaysOfWeek[DaysOfWeek["Monday"] = 1] = "Monday";
            DaysOfWeek[DaysOfWeek["Tuesday"] = 2] = "Tuesday";
            DaysOfWeek[DaysOfWeek["Wednesday"] = 4] = "Wednesday";
            DaysOfWeek[DaysOfWeek["Thursday"] = 8] = "Thursday";
            DaysOfWeek[DaysOfWeek["Friday"] = 16] = "Friday";
            DaysOfWeek[DaysOfWeek["Saturday"] = 32] = "Saturday";
            DaysOfWeek[DaysOfWeek["Sunday"] = 64] = "Sunday";
        })(DaysOfWeek = Firmware.DaysOfWeek || (Firmware.DaysOfWeek = {}));
    })(Firmware = Flatbuffers.Firmware || (Flatbuffers.Firmware = {}));
})(Flatbuffers || (Flatbuffers = {}));
;
/**
 * @constructor
 */
(function (Flatbuffers) {
    var Firmware;
    (function (Firmware) {
        class ThermostatSetting {
            constructor() {
                this.bb = null;
                this.bb_pos = 0;
            }
            /**
             * @param number i
             * @param flatbuffers.ByteBuffer bb
             * @returns ThermostatSetting
             */
            __init(i, bb) {
                this.bb_pos = i;
                this.bb = bb;
                return this;
            }
            ;
            /**
             *
             * We won't bother making a formal union out of this since that'll just end up taking more space
             * than what we could hope to save.
             *
             *
             * @returns number
             */
            setPointHeatX100() {
                return this.bb.readUint16(this.bb_pos);
            }
            ;
            /**
             * @returns number
             */
            setPointCoolX100() {
                return this.bb.readUint16(this.bb_pos + 2);
            }
            ;
            /**
             * @returns number
             */
            setPointCirculateAboveX100() {
                return this.bb.readUint16(this.bb_pos + 4);
            }
            ;
            /**
             * @returns number
             */
            setPointCirculateBelowX100() {
                return this.bb.readUint16(this.bb_pos + 6);
            }
            ;
            /**
             * @returns Flatbuffers.Firmware.ThermostatAction
             */
            allowedActions() {
                return /**  */ (this.bb.readUint8(this.bb_pos + 8));
            }
            ;
            /**
             * @returns Flatbuffers.Firmware.ThermostatSettingType
             */
            type() {
                return /**  */ (this.bb.readUint8(this.bb_pos + 9));
            }
            ;
            /**
             * @returns number
             */
            Padding0() {
                return this.bb.readUint16(this.bb_pos + 10);
            }
            ;
            /**
             * For Hold settings
             * holdUntil: seconds since UTC epoch
             *
             * @returns number
             */
            holdUntil() {
                return this.bb.readUint32(this.bb_pos + 12);
            }
            ;
            /**
             * For Scheduled settings
             *
             * @returns Flatbuffers.Firmware.DaysOfWeek
             */
            daysOfWeek() {
                return /**  */ (this.bb.readUint8(this.bb_pos + 16));
            }
            ;
            /**
             * @returns number
             */
            Padding1() {
                return this.bb.readUint8(this.bb_pos + 17);
            }
            ;
            /**
             * @returns number
             */
            atMinutesSinceMidnight() {
                return this.bb.readUint16(this.bb_pos + 18);
            }
            ;
            /**
             * @param flatbuffers.Builder builder
             * @param number setPointHeat_x100
             * @param number setPointCool_x100
             * @param number setPointCirculateAbove_x100
             * @param number setPointCirculateBelow_x100
             * @param Flatbuffers.Firmware.ThermostatAction allowedActions
             * @param Flatbuffers.Firmware.ThermostatSettingType type
             * @param number _padding0
             * @param number holdUntil
             * @param Flatbuffers.Firmware.DaysOfWeek daysOfWeek
             * @param number _padding1
             * @param number atMinutesSinceMidnight
             * @returns flatbuffers.Offset
             */
            static createThermostatSetting(builder, setPointHeat_x100, setPointCool_x100, setPointCirculateAbove_x100, setPointCirculateBelow_x100, allowedActions, type, _padding0, holdUntil, daysOfWeek, _padding1, atMinutesSinceMidnight) {
                builder.prep(4, 20);
                builder.writeInt16(atMinutesSinceMidnight);
                builder.writeInt8(_padding1);
                builder.writeInt8(daysOfWeek);
                builder.writeInt32(holdUntil);
                builder.writeInt16(_padding0);
                builder.writeInt8(type);
                builder.writeInt8(allowedActions);
                builder.writeInt16(setPointCirculateBelow_x100);
                builder.writeInt16(setPointCirculateAbove_x100);
                builder.writeInt16(setPointCool_x100);
                builder.writeInt16(setPointHeat_x100);
                return builder.offset();
            }
            ;
        }
        Firmware.ThermostatSetting = ThermostatSetting;
    })(Firmware = Flatbuffers.Firmware || (Flatbuffers.Firmware = {}));
})(Flatbuffers || (Flatbuffers = {}));
/**
 *
 * Defaults are provided so the firmware can reset itself if state got corrupted.
 *
 *
 * @constructor
 */
(function (Flatbuffers) {
    var Firmware;
    (function (Firmware) {
        class ThermostatConfiguration {
            constructor() {
                this.bb = null;
                this.bb_pos = 0;
            }
            /**
             * @param number i
             * @param flatbuffers.ByteBuffer bb
             * @returns ThermostatConfiguration
             */
            __init(i, bb) {
                this.bb_pos = i;
                this.bb = bb;
                return this;
            }
            ;
            /**
             * @param flatbuffers.ByteBuffer bb
             * @param ThermostatConfiguration= obj
             * @returns ThermostatConfiguration
             */
            static getRootAsThermostatConfiguration(bb, obj) {
                return (obj || new ThermostatConfiguration).__init(bb.readInt32(bb.position()) + bb.position(), bb);
            }
            ;
            /**
             * @param flatbuffers.ByteBuffer bb
             * @returns boolean
             */
            static bufferHasIdentifier(bb) {
                return bb.__has_identifier('WAF3');
            }
            ;
            /**
             * @returns flatbuffers.Long
             */
            externalSensorId() {
                var offset = this.bb.__offset(this.bb_pos, 4);
                return offset ? this.bb.readUint64(this.bb_pos + offset) : this.bb.createLong(0, 0);
            }
            ;
            /**
             * @returns number
             */
            thresholdX100() {
                var offset = this.bb.__offset(this.bb_pos, 6);
                return offset ? this.bb.readUint16(this.bb_pos + offset) : 50;
            }
            ;
            /**
             * @returns number
             */
            cadence() {
                var offset = this.bb.__offset(this.bb_pos, 8);
                return offset ? this.bb.readUint16(this.bb_pos + offset) : 600;
            }
            ;
            /**
             * {current,next}TimezoneUTCOffset: signed IANA UTC offset, e.g. PST = 480
             *
             * @returns number
             */
            currentTimezoneUTCOffset() {
                var offset = this.bb.__offset(this.bb_pos, 10);
                return offset ? this.bb.readInt16(this.bb_pos + offset) : 0;
            }
            ;
            /**
             * @returns number
             */
            nextTimezoneUTCOffset() {
                var offset = this.bb.__offset(this.bb_pos, 12);
                return offset ? this.bb.readInt16(this.bb_pos + offset) : 0;
            }
            ;
            /**
             * nextTimezoneChange: seconds since UTC epoch when nextTimezoneUTCOffset becomes applicable
             *
             * @returns number
             */
            nextTimezoneChange() {
                var offset = this.bb.__offset(this.bb_pos, 14);
                return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
            }
            ;
            /**
             * @param number index
             * @param Flatbuffers.Firmware.ThermostatSetting= obj
             * @returns Flatbuffers.Firmware.ThermostatSetting
             */
            thermostatSettings(index, obj) {
                var offset = this.bb.__offset(this.bb_pos, 16);
                return offset ? (obj || new Flatbuffers.Firmware.ThermostatSetting).__init(this.bb.__vector(this.bb_pos + offset) + index * 20, this.bb) : null;
            }
            ;
            /**
             * @returns number
             */
            thermostatSettingsLength() {
                var offset = this.bb.__offset(this.bb_pos, 16);
                return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
            }
            ;
            /**
             * @param flatbuffers.Builder builder
             */
            static startThermostatConfiguration(builder) {
                builder.startObject(7);
            }
            ;
            /**
             * @param flatbuffers.Builder builder
             * @param flatbuffers.Long externalSensorId
             */
            static addExternalSensorId(builder, externalSensorId) {
                builder.addFieldInt64(0, externalSensorId, builder.createLong(0, 0));
            }
            ;
            /**
             * @param flatbuffers.Builder builder
             * @param number thresholdX100
             */
            static addThresholdX100(builder, thresholdX100) {
                builder.addFieldInt16(1, thresholdX100, 50);
            }
            ;
            /**
             * @param flatbuffers.Builder builder
             * @param number cadence
             */
            static addCadence(builder, cadence) {
                builder.addFieldInt16(2, cadence, 600);
            }
            ;
            /**
             * @param flatbuffers.Builder builder
             * @param number currentTimezoneUTCOffset
             */
            static addCurrentTimezoneUTCOffset(builder, currentTimezoneUTCOffset) {
                builder.addFieldInt16(3, currentTimezoneUTCOffset, 0);
            }
            ;
            /**
             * @param flatbuffers.Builder builder
             * @param number nextTimezoneUTCOffset
             */
            static addNextTimezoneUTCOffset(builder, nextTimezoneUTCOffset) {
                builder.addFieldInt16(4, nextTimezoneUTCOffset, 0);
            }
            ;
            /**
             * @param flatbuffers.Builder builder
             * @param number nextTimezoneChange
             */
            static addNextTimezoneChange(builder, nextTimezoneChange) {
                builder.addFieldInt32(5, nextTimezoneChange, 0);
            }
            ;
            /**
             * @param flatbuffers.Builder builder
             * @param flatbuffers.Offset thermostatSettingsOffset
             */
            static addThermostatSettings(builder, thermostatSettingsOffset) {
                builder.addFieldOffset(6, thermostatSettingsOffset, 0);
            }
            ;
            /**
             * @param flatbuffers.Builder builder
             * @param number numElems
             */
            static startThermostatSettingsVector(builder, numElems) {
                builder.startVector(20, numElems, 4);
            }
            ;
            /**
             * @param flatbuffers.Builder builder
             * @returns flatbuffers.Offset
             */
            static endThermostatConfiguration(builder) {
                var offset = builder.endObject();
                return offset;
            }
            ;
            /**
             * @param flatbuffers.Builder builder
             * @param flatbuffers.Offset offset
             */
            static finishThermostatConfigurationBuffer(builder, offset) {
                builder.finish(offset, 'WAF3');
            }
            ;
            static createThermostatConfiguration(builder, externalSensorId, thresholdX100, cadence, currentTimezoneUTCOffset, nextTimezoneUTCOffset, nextTimezoneChange, thermostatSettingsOffset) {
                ThermostatConfiguration.startThermostatConfiguration(builder);
                ThermostatConfiguration.addExternalSensorId(builder, externalSensorId);
                ThermostatConfiguration.addThresholdX100(builder, thresholdX100);
                ThermostatConfiguration.addCadence(builder, cadence);
                ThermostatConfiguration.addCurrentTimezoneUTCOffset(builder, currentTimezoneUTCOffset);
                ThermostatConfiguration.addNextTimezoneUTCOffset(builder, nextTimezoneUTCOffset);
                ThermostatConfiguration.addNextTimezoneChange(builder, nextTimezoneChange);
                ThermostatConfiguration.addThermostatSettings(builder, thermostatSettingsOffset);
                return ThermostatConfiguration.endThermostatConfiguration(builder);
            }
        }
        Firmware.ThermostatConfiguration = ThermostatConfiguration;
    })(Firmware = Flatbuffers.Firmware || (Flatbuffers.Firmware = {}));
})(Flatbuffers || (Flatbuffers = {}));
//# sourceMappingURL=firmware_generated.js.map